export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'

const userRole = getUserRole()
const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: filterRoutesByRole(
    [
      {
        name: 'dashboard',
        displayName: 'Admin Dashboard',
        meta: {
          icon: 'dashboard',
          allowedRoles: ['org_admin'],
        },
        children: [
          {
            name: 'dashboard',
            displayName: 'Overview',
            meta: {
              icon: 'overview',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'analytics',
            displayName: 'Analytics',
            meta: {
              icon: 'analytics',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'reports',
            displayName: 'Reports',
            meta: {
              icon: 'assessment',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'odometer-reports',
            displayName: 'Odometer Reports',
            meta: {
              icon: 'speed',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'charging-reports',
            displayName: 'Charging Reports',
            meta: {
              icon: 'battery_charging_full',
              allowedRoles: ['org_admin'],
            },
          },
        ],
      },
      {
        name: 'platform-config',
        displayName: 'Platform Configuration',
        meta: {
          icon: 'settings_applications',
          allowedRoles: ['org_admin'],
        },
        children: [
          {
            name: 'users',
            displayName: 'User Management',
            meta: {
              icon: 'group',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'operators',
            displayName: 'Operators',
            meta: {
              icon: 'support_agent',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'role-management',
            displayName: 'Role Management',
            meta: {
              icon: 'security',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'user-management',
            displayName: 'User Management',
            meta: {
              icon: 'admin_panel_settings',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'docs',
            displayName: 'Docs',
            meta: {
              icon: 'menu_book',
              allowedRoles: ['org_admin'],
            },
            children: [
              {
                name: 'docs',
                displayName: 'Main',
                meta: {
                  icon: 'menu_book',
                  allowedRoles: ['org_admin'],
                },
              },
              {
                name: 'docs-system',
                displayName: 'System',
                meta: {
                  icon: 'hub',
                  allowedRoles: ['org_admin'],
                },
              },
            ],
          },
        ],
      },
      {
        name: 'fleet-management',
        displayName: 'Fleet Management',
        meta: {
          icon: 'commute',
          allowedRoles: ['org_admin'],
        },
        children: [
          {
            name: 'drivers',
            displayName: 'Drivers',
            meta: {
              icon: 'moped',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'our-drivers',
            displayName: 'Our Drivers',
            meta: {
              icon: 'person',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'vehicles',
            displayName: 'Vehicles',
            meta: {
              icon: 'directions_car',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'our-vehicles',
            displayName: 'Our Vehicles',
            meta: {
              icon: 'directions_car',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'bikes',
            displayName: 'Bikes',
            meta: {
              icon: 'two_wheeler',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'trips',
            displayName: 'Trips',
            meta: {
              icon: 'route',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'alarms',
            displayName: 'Alarms',
            meta: {
              icon: 'notifications',
              allowedRoles: ['org_admin'],
            },
          },
        ],
      },
      {
        name: 'operations',
        displayName: 'Operations',
        meta: {
          icon: 'engineering',
          allowedRoles: ['org_admin'],
        },
        children: [
          {
            name: 'maintenance',
            displayName: 'Maintenance',
            meta: {
              icon: 'build',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'maintenance-items',
            displayName: 'Maintenance Items',
            meta: {
              icon: 'inventory',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'maintenance-workshops',
            displayName: 'Workshops',
            meta: {
              icon: 'business',
              allowedRoles: ['org_admin'],
            },
          },
          {
            name: 'tickets',
            displayName: 'Tickets',
            meta: {
              icon: 'assignment',
              allowedRoles: ['org_admin'],
            },
          },
        ],
      },
      {
        name: 'finance',
        displayName: 'Finance',
        meta: {
          icon: 'account_balance',
          allowedRoles: ['org_admin'],
        },
        children: [
          {
            name: 'billing',
            displayName: 'Billing',
            meta: {
              icon: 'receipt',
              allowedRoles: ['org_admin'],
            },
          },
        ],
      },
      {
        name: 'settings',
        displayName: 'Settings',
        meta: {
          icon: 'settings',
          allowedRoles: ['org_admin'],
        },
      },
      {
        name: 'preferences',
        displayName: 'Profile',
        meta: {
          icon: 'manage_accounts',
          allowedRoles: ['org_admin'],
        },
      },
    ],
    userRole,
  ),
}

export default sidebarRoutes
